import { createSelector } from "reselect";

const getNeoImporterState = state => state.neoimporter;

export const getNeoImportersList = createSelector(
    getNeoImporterState,
    state => state.list || []
);

export const getNeoImportersPagination = createSelector(
    getNeoImporterState,
    state => state.pagination
);

export const getNeoImportersLoading = createSelector(
    getNeoImporterState,
    state => state.loading
);

export const getNeoImportersLoaded = createSelector(
    getNeoImporterState,
    state => state.loaded
);

export const getNeoImportersFilters = createSelector(
    getNeoImporterState,
    state => state.filters
);

export default {
    getNeoImportersList,
    getNeoImportersPagination,
    getNeoImportersLoading,
    getNeoImportersLoaded,
    getNeoImportersFilters
};
